import React, { memo, useCallback, useEffect, useState } from 'react';
import { Vehicle } from '@app/models';
import { getAllBrands } from '@app/api';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Label } from '../ui/label';

interface BrandSelectProps {
  onChange: (value: string) => void;
  index?: number;
  item?: ISelectOption[];
  onSelectedLists?: (item: any[]) => void;
}

interface ISelectOption {
  label: string;
  value: string;
}

const defaultOption = {
  label: 'Все' as const,
  value: 'all' as const,
};

function BrandSelect(props: BrandSelectProps) {
  const { onChange } = props;
  const [options, setOptions] = useState<ISelectOption[]>([]);

  const onChangeSelect = useCallback(
    (selectedValue: string) => {
      const isSelectedAll = selectedValue === defaultOption.value;
      const option = selectedValue ?? '';

      onChange(isSelectedAll ? '' : option);
    },
    [onChange]
  );

  const getData = useCallback(async () => {
    try {
      setOptions([]);
      const brandList = await getAllBrands();
      const brandOptions = brandList.map((item) => ({
        label: item,
        value: item,
      }));

      setOptions([defaultOption, ...brandOptions]);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await getData();
    })();
  }, [getData]);

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">ВЫБЕРИТЕ МОДЕЛЬ</Label>
      <Select onValueChange={onChangeSelect}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Выберите" />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default memo(BrandSelect);
